import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import moment from 'moment';

import { DATE_TIME_FORMAT } from '@/config';
import { IIncidentCode } from '@/models';

const number = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row?.number || '-',
  valueGetter: (_, row) => row?.number,
});

const incidentCodes = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    const codes = params.row?.incidentCodes || [];
    return (
      codes
        .map((code: IIncidentCode) =>
          code.description ? `${code.code} - ${code.description}` : code.code,
        )
        .join(', ') || '-'
    );
  },
  valueGetter: (_, row) => {
    const codes = row?.incidentCodes || [];
    return codes
      .map((code: IIncidentCode) =>
        code.description ? `${code.code} - ${code.description}` : code.code,
      )
      .join(', ');
  },
});

const createdAt = (): Partial<GridColDef> => ({
  renderCell: (params) => {
    const dateString =
      params.row?.reporter?.reportTime || params.row?.createdAt;
    return dateString ? moment(dateString).format(DATE_TIME_FORMAT) : '-';
  },
  valueGetter: (_, row) => {
    const dateString = row?.reporter?.reportTime || row?.createdAt;
    return dateString ? moment(dateString).format(DATE_TIME_FORMAT) : '';
  },
});

const shortDescription = (): Partial<GridColDef> => ({
  renderCell: (params) => params.row?.shortDescription || '-',
  valueGetter: (_, row) => row?.shortDescription,
});

const actions = (handleView?: (id: string) => void): Partial<GridColDef> => ({
  sortable: false,
  renderCell: (params) => (
    <Button
      variant="text"
      color="primary"
      onClick={(e) => {
        e.stopPropagation();
        handleView?.(params.row._id);
      }}
    >
      View CFS
    </Button>
  ),
});

export const cfsHistoryCols = (handleView?: (id: string) => void) => {
  return {
    number,
    incidentCodes,
    createdAt,
    shortDescription,
    actions: () => actions(handleView),
  };
};
